import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface LeadFieldsState {
  filters?: {
    searchText?: string;
    searchFilters?: {
      id?: number;
      data_type?: string;
      lead_attribute_type?: string;
      created_by_id?: number;
      [key: string]: any;
    };
  };
  pagination: {
    itemsPerPage: number;
    currentPage: number;
  };
}

const initialState: LeadFieldsState = {
  pagination: {
    itemsPerPage: 10,
    currentPage: 1,
  },
};

export const leadFieldsSlice = createSlice({
  name: 'leadFields',
  initialState,
  reducers: {
    setLeadFieldFilter: (state, action: PayloadAction<Partial<LeadFieldsState['filters']>>) => {
      if (action.payload) {
        state.filters = {
          ...state.filters,
          ...action.payload,
        };
      }
    },
    setLeadFieldPagination: (state, action: PayloadAction<Partial<LeadFieldsState['pagination']>>) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
    resetLeadFieldFilter: (state, action: PayloadAction<keyof NonNullable<LeadFieldsState['filters']>>) => {
      const { [action.payload]: discardedValue, ...rest } = state.filters || {};
      state.filters = rest;
    },
    setLeadFieldSearchFilter: (state, action: PayloadAction<{ key: string, value: any }>) => {
      const { key, value } = action.payload;
      if (!state.filters) state.filters = {};

      if (value === undefined || value === null) {
        if (state.filters.searchFilters) {
          const { [key]: discardedValue, ...rest } = state.filters.searchFilters;
          state.filters.searchFilters = Object.keys(rest).length > 0 ? rest : undefined;
        }
      } else {
        state.filters.searchFilters = {
          ...state.filters.searchFilters,
          [key]: value,
        };
      }
    },
    resetLeadFieldSearchFilter: (state, action: PayloadAction<string>) => {
      if (state.filters?.searchFilters) {
        const { [action.payload]: discardedValue, ...rest } = state.filters.searchFilters as Record<string, unknown>;
        state.filters.searchFilters = Object.keys(rest).length > 0 ? rest : undefined;
      }
    },
  },
});

export const {
  setLeadFieldFilter,
  resetLeadFieldFilter,
  setLeadFieldPagination,
  setLeadFieldSearchFilter,
  resetLeadFieldSearchFilter,
} = leadFieldsSlice.actions;

export default leadFieldsSlice.reducer;
